export default __webpack_public_path__ + "static/media/hm-bg-shape.270712f6.jpg";